import React, { useState, useRef, useEffect } from "react";
import { useFormik, FormikProps } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getAuthCookie } from "../../utils/authCookies";

const TeammemberAddAttribute = () => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = getAuthCookie("sessionToken");

  const formik = useFormik<{
    name: string;
    parameters: string;
    description: string;
    statuss: string;
  }>({
    initialValues: {
      name: "",
      parameters: "",
      description: "",
      statuss: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, "Name must be at least 2 characters long")
        .max(50, "Name cannot be longer than 50 characters")
        .required("Name is required"),
      statuss: Yup.string().required("Status is required"),
    }),
    onSubmit: async (values) => {
      try {
        const attributeStatus = values.statuss === "Active" ? true : false;
        const response = await fetch(`${process.env.REACT_APP_API_URL}/product-attributes`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: values.name,
            values: values.parameters.split(","),
            description: values.description,
            status: attributeStatus,
          }),
        });
    
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || "Failed to create attribute");
        }
    
        navigate("/teammember/attributes", {
          state: { successMessage: "Attribute added successfully!" },
        });
        toast.success("Attribute added successfully!");
      } catch (error: any) {
        console.error(error);
        toast.error(`Error: ${error.message}`);
      } finally {
        setFormSubmitting(false);
      }
    }        
  });

  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Add Attribute</h2>

          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="p-2 mt-4">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            {/* Name Field */}
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.name}
                              />
                              {formik.touched.name && formik.errors.name ? (
                                <div className="invalid-feedback">
                                  {formik.errors.name}
                                </div>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Values <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="parameters"
                                name="parameters"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.parameters}
                              />
                              {formik.touched.parameters && formik.errors.parameters ? (
                                <div className="invalid-feedback">
                                  {formik.errors.parameters}
                                </div>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Description 
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="description"
                                name="description"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.description}
                              />
                              {formik.touched.description && formik.errors.description ? (
                                <div className="invalid-feedback">
                                  {formik.errors.description}
                                </div>
                              ) : null}
                            </div>
                            {/* Status Field */}
                            <div className="col-md-6 mb-3">
                              <label className="form-label">
                                Status <span className="text-danger">*</span>
                              </label>
                              <select
                               className="form-control"
                                id="statuss"
                                name="statuss"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.statuss}
                              >
                                <option value="">- Select -</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                              {formik.touched.statuss &&
                              formik.errors.statuss ? (
                                <div className="invalid-feedback">
                                  {formik.errors.statuss}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                       
                      </div>

                      {/* Submit Button */}
                      <div className="mt-4">
                        <button
                          className="btn btn-success w-100"
                          type="submit"
                          disabled={formSubmitting}
                        >
                          {formSubmitting ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeammemberAddAttribute;
